import { render, staticRenderFns } from "./InputCategoriesList.vue?vue&type=template&id=46411042"
import script from "./InputCategoriesList.vue?vue&type=script&lang=js"
export * from "./InputCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports